import React from 'react';
import { TouchableOpacity, StyleSheet } from 'react-native';
import { CheckBox } from '@rneui/themed';
import FormField from './FormField';
import { useLanguage } from '../../context/LanguageContext';

const styles = StyleSheet.create({
    touchContent: {
        width: '100%',
    },
});

interface Props {
    value: any[];
    item: any;
    setFieldValue: (data: any[]) => void;
    style: Record<string, any>;
}

const CheckBoxItemForm: React.FC<Props> = ({
    value,
    item,
    setFieldValue,
    style,
}) => {
    console.log('value', value);

    const { currentLanguage } = useLanguage();

    const [check, setCheck] = React.useState(
        (value &&
            Array.isArray(value) &&
            value.find((itm) => itm.id === item.id) !== undefined) ||
            (value && Array.isArray(value) && value?.includes(item.id))
    );

    const handleCheckBoxToggle = (item: any): void => {
        if (
            Array.isArray(value) &&
            value.find((itm) => itm.id === item.id) !== undefined
        ) {
            setFieldValue(value.filter((itm) => itm.id !== item.id));
        } else if (Array.isArray(value) && value.includes(item)) {
            setFieldValue(value.filter((itm) => itm !== item));
        } else {
            setFieldValue([...value, item]);
        }
    };

    return (
        <TouchableOpacity
            onPress={() => {
                setCheck(!check);
                handleCheckBoxToggle(item);
            }}
            style={style.touchContent}
        >
            <CheckBox
                title={item.name[currentLanguage]}
                checked={check}
                onPress={() => {
                    setCheck(!check);
                    handleCheckBoxToggle(item);
                }}
            />
        </TouchableOpacity>
    );
};

CheckBoxItemForm.defaultProps = {
    style: styles,
};

export default FormField(CheckBoxItemForm);
